import useSWR from 'swr'
import API from '../../../utils/api'
import { CHARTAPI, INDEXPIRCE } from '../../constants/TRADEAPIKEYS'
import { useToken } from '../auth/token'

let lastcall: any = null
let swrData:any = null;
let lastApiCall: number = 0; // API 마지막 호출 시간

export function useIndexPrice(symbol:string) {
	const { data: token } = useToken()


	// 모든 ep_id에 대해 동일한 KEY 사용 (ep_id=0으로 모든 데이터 가져오기)
	let KEY: any = INDEXPIRCE + '?symbol=0'

	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			const now = new Date().getTime()
			const FIVE_MINUTES = 5 * 60 * 1000 // 5분 = 300,000ms

			// swrData가 없거나, 5분 이상 지났으면 API 호출
			if(swrData == null || swrData == undefined || (now - lastApiCall) >= FIVE_MINUTES){
				const response = await API.get(KEY, token + '', {}, false, CHARTAPI + '/v1')
				swrData = response?.result || []
				lastApiCall = now // API 호출 시간 갱신
				return swrData
			}else{
				return swrData
			}
		},
		{
			revalidateOnFocus: false,     // 포커스 시 재검증 비활성화
			revalidateOnReconnect: true,
			revalidateOnMount: true,      // 첫 마운트 시에만 호출
			revalidateIfStale: false,     // stale 상태 재검증 안함
			dedupingInterval: 10000,      // 10초간 중복 방지
			refreshInterval: 60000,       // 1분마다 체크 (5분마다 실제 API 호출)
		}
	)

	const list =
		(data &&
			data?.length >= 0 &&
			data?.find((item: any) => item?.symbol == symbol)?.result) ||
		[]
	return {
		data: list,
		reset: (where?: string) => {
			const now = new Date().getTime()
			if (lastcall != null && now - lastcall < 10000) {
				return
			}
			lastcall = now
			mutate()
		},
		mutate: (value?: any, symbol?: string) => {
			try {
				return mutate((prev: any) => {
					if (!prev || !Array.isArray(prev)) return prev


					const existingIndex = prev.findIndex((item: any) => item?.symbol == symbol)


					if (existingIndex >= 0) {
						// 기존 항목 업데이트
						const updated = [...prev]
						updated[existingIndex] = {
							symbol: symbol,
							result: { ...value },
						}
						swrData = updated
						return swrData
					} else {
						// 새 항목 추가
						swrData =  [
							...prev,
							{
								symbol: symbol,
								result: { ...value },
							},
						]

						return swrData
					}
				})
			} catch (e) {
				console.error("INDEXPRICE", e);
				return mutate()
			}
		},
		getPrice: (symbol?: string) => {
			try {
				const price = data?.find((item: any) => item?.symbol == symbol)?.result?.[0]?.price || 0
				return price
			} catch (e) {
				return 0
			}
		},
	}
}
